
import React from 'react'
import { styled } from 'styled-components'
import { DownFill,CheckOutline,LeftOutline } from 'antd-mobile-icons'
import _ from 'lodash'
import { Popup } from 'antd-mobile'
import { FilterHeader } from '../Common/FilterHeader'
import { getAppSafeTopArea } from '@/utils/utils'



enum CheckStatus {
  checkedAll,
  checkedPartial,
  notChecked
}

function getCheckedStatusValue (options: TreeSelectPropsOption[],value:OptionValue){
  const checkedAllValue:OptionValue = []
  const checkedPartialValue:OptionValue = []
  processCheckedPartial(options)
  return {  checkedAllValue, checkedPartialValue }
  function  processCheckedPartial (options: TreeSelectPropsOption[]):{checkStatus:CheckStatus}{
    let hasPartialChecked = false;
    let notChecked = false
    let hasChecked = false
    let status:CheckStatus = CheckStatus.notChecked
    for(let option of options){
      if(option.children){
        let status = processCheckedPartial(option.children)
        switch(status.checkStatus){
          case CheckStatus.checkedPartial:
            hasPartialChecked = true
            checkedPartialValue.push(option.value)
            break
          case CheckStatus.notChecked:
            notChecked = true
            break
          case CheckStatus.checkedAll:
            hasChecked = true
            checkedAllValue.push(option.value)
            break
        }
      }else{
        if(value.includes(option.value)){
          hasChecked = true
        }else{
          notChecked = true
        }
      }
    }
    if(hasChecked){
      if(notChecked || hasPartialChecked){
        status = CheckStatus.checkedPartial
      }else{
        status = CheckStatus.checkedAll
      }
    }else{
      if(hasPartialChecked){
        status = CheckStatus.checkedPartial
      }else{
        status = CheckStatus.notChecked
      }
    }
    return {checkStatus: status}
  }
}



function getUpdateValue(values:OptionValue,node:TreeSelectPropsOption){
  let value = node.value
  const childrenChecked = (node:TreeSelectPropsOption):boolean=>{
    if(!node.children){
      return  false
    }
    return node.children.every(child =>{
      if(child.children){
        return childrenChecked(child)
      }else{
        return values.includes(child.value)
      }
    })
  } 
  const getChildrenValue = (node:TreeSelectPropsOption)=>{
    let children = node.children || []
    const getValue = (options:TreeSelectPropsOption[] ):OptionValueItem[]=>{
      let childrenIds =  options.map(option=>{
        if(!option.children){
          return [option.value]
        }
        return getValue(option.children)
      })
      return _.flatMapDeep(childrenIds)
    }
    return getValue(children)
  }
  if(node.children){
    let allChecked = childrenChecked(node);
    let childrenValue  = getChildrenValue(node);
    if(allChecked){
      values = values.filter( value => !childrenValue.includes(value) )
    }else{
      childrenValue.forEach(item =>{
        if(!values.includes(item)){
          values.push(item)
        }
      })
    }
  }else{
    let valueIndex = values.indexOf(value);
    if (valueIndex > -1) {
      values.splice(valueIndex, 1)
    } else {
      values.push(value);
    }
  }
  return values
}

const TreeSelectView = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .tree-item{

  }
  .tree-body{
    padding-left: 15px;
    flex: 1;
    overflow-y: auto;
  }
  .tree-label{
    height: 44px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #efefef;
    .label-text{
      flex:1;
      display: flex;
      padding-right: 15px;
      height: 100%;
      align-items: center;
      .text{
        flex: 1;
      }
    }
  }
  .tree-option{

  }
  .tree-arrow{
    transform: rotateZ(-90deg);
    margin-right: 10px;
    &.active{
      transform: rotateZ(0deg);
    }
  }

`

export const getOptionLabels = (options:TreeSelectPropsOption[],value:any[])=>{
  let labels:TreeSelectPropsOption[] = []
  const getValue = (options: TreeSelectPropsOption[]) => {
    options.forEach(option => {
      if (value.includes(option.value)) {
        labels.push(option)
      }
      return getValue(option.children || [])
    })
  }
  getValue(options)
  return labels
}

type OptionValueItem = number | string
// type OptionValueItem = TreeSelectPropsOption

export type TreeSelectPropsOption = {
  label: string,
  value: OptionValueItem
  children?: TreeSelectPropsOption[]
}

type OptionValue = Array<OptionValueItem>
interface TreePickProps {
  options: TreeSelectPropsOption[],
  value?: Array<string|number>
  onChange?: (value: Array<string|number>,option:TreeSelectPropsOption) => void
  visible?:boolean,
  header?:React.ReactNode
  onClose?():void
  loading?:boolean
}




export const TreePick = (props: TreePickProps) => {
  const [value,setValue] = React.useState<OptionValue>( []);
  const [activeId, setActiveId] = React.useState<OptionValue>([])
  const { options } = props
  const [ partialChecked, setPartialChecked ] = React.useState<OptionValue>([])
  const [ allChecked,setAllChecked ] = React.useState<OptionValue>([])
  React.useEffect(()=>{
    setValue(props.value || [])
  },[props.value] )
  const onChangeActive = (value: OptionValueItem) => {
    setActiveId(activeId => {
      let activeIndex = activeId.indexOf(value)
      if (activeIndex > -1) {
        activeId.splice(activeIndex, 1)
      } else {
        activeId.push(value)
      }
      return [...activeId]
    })
  }

  React.useEffect(()=>{
    let { checkedAllValue ,checkedPartialValue}  = getCheckedStatusValue(options,value)
    setPartialChecked(checkedPartialValue)
    setAllChecked(checkedAllValue)
  },[value])
  const onChangeValue = (node: TreeSelectPropsOption,)=>{
    setValue(oldValue => {
      let values = [...oldValue]
      values = getUpdateValue(values,node)
      let valueItems = getOptionLabels(options,values);
      props?.onChange?.(valueItems.map(item=> item.value), node);
      return values
    })
  }
  const renderOptions = (options: TreeSelectPropsOption[] | undefined, level: number,ancestorIds:OptionValueItem[] = []) => {
    if (!options || !options.length) {
      return null
    }
    let padding = level * 20
    return <div className='tree-option' >
      {options.map(option => {
        let hasChildren = option.children

        let isActive = activeId.includes(option.value);
        let isChecked = allChecked.includes(option.value) ||  value.includes(option.value);
        let isPartialChecked = partialChecked.includes(option.value)
        const renderChildren = () => {
          if (!isActive) {
            return null
          }
          return <div className='tree-children'>
            {renderOptions(option.children, level+1,[...ancestorIds, option.value])}
          </div>
        }
        return <div className='tree-item' >
          <div className='tree-label' style={{ paddingLeft: `${padding}px` }}>
            {hasChildren ? <DownFill className={`tree-arrow ${isActive ? 'active' : ''}`} onClick={() => onChangeActive(option.value)} /> : <div style={{width:'23px'}}></div>}
            <div  className='label-text' onClick={()=>onChangeValue(option)} >
              <div className='text'>{option.label}</div>
              { isChecked && <CheckOutline className='check-arrow' fontSize={20} color="#3487ed" /> }
              { isPartialChecked && <CheckOutline className='check-arrow' style={{opacity:'0.5'}} fontSize={20} color="#3487ed" />}
            </div>
          </div>
          {renderChildren()}
        </div>
      })}
    </div>
  }
  let renderPlaceHolderText = ()=>{
    if(!options.length){
      if(props.loading){
        return <div style={{textAlign:'center'}}>加载中...</div>
      }
      return <div style={{textAlign:'center'}}>暂无数据</div>
    }
    return null
  }
  return <Popup
    position='right'
    className="filter-wrap-modal"
    closeOnMaskClick
    destroyOnClose
    bodyStyle={{width:'100%'}}
    visible={ props.visible }
    onClose={ props?.onClose }
  >
    <TreeSelectView >
      <FilterHeader onClose={ props?.onClose }  text={ props.header }/>
      {  renderPlaceHolderText() }
      <div className='tree-body'>
       { renderOptions(options, 0) }
      </div>
    </TreeSelectView>
  </Popup>
}

